import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PostDisplayListComponent } from './post-display-list/post-display-list.component';
import { PostDisplayComponent } from './post-display/post-display.component';
import { PostComponent } from './post/post.component';
import { PostComponentModule } from './components/post-component.module';
import { RouterModule } from '@angular/router';
import { CommentEditPopinComponent } from './comment-edit-popin/comment-edit-popin.component';
import { MediaModule } from '../media/media.module';
import { PostMetasService } from './post-metas.service';
import { UtilsModule } from '../../utils/utils.module';
import { PostsFluxModule } from '../../shared/components/posts-flux/posts-flux.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ContentPlaceholderModule } from '../../kz-ui/ui/content-placehoder/content-placeholder.module';
import { KzModalModule } from '../../kz-ui/ui/modal/kz-modal.module';
import {
  PostMemoryShareDisplayComponent
} from 'src/app/modules/post/post-memory-share-display/post-memory-share-display.component';
import { PostMemoryShareComponent } from 'src/app/modules/post/post-memory-share/post-memory-share.component';
import { KzFormModule } from '../../kz-ui/ui/form/kz-form.module';
import { KzIconsModule } from '../../kz-ui/ui/icon/kz-icons.module';
import { LandingApiModule } from '@adeo/ngx-kozikaza-api/landing';
import { KzLocalizePipe } from "../../utils/pipes/i18n/kz-localize.pipe";

@NgModule({
  imports: [
    LandingApiModule,
    SharedModule,
    CommonModule,
    FormsModule,
    RouterModule,
    PostComponentModule,
    PostsFluxModule,
    UtilsModule,
    MediaModule,
    TranslateModule.forChild(),
    ContentPlaceholderModule,
    KzModalModule,
    KzFormModule,
    KzIconsModule,
    KzLocalizePipe,
  ],
  declarations: [
    PostComponent,
    PostMemoryShareComponent,
    PostDisplayComponent,
    PostMemoryShareDisplayComponent,
    PostDisplayListComponent,
    CommentEditPopinComponent,
  ],
  exports: [],
  providers: [
    PostMetasService,
  ]
})
export class PostDisplayModule {
}
